import { NotificationsComponent } from './notifications.component';

export const NotificationsRoutes: Array<any> = [
  {
    path: 'notifications',
    component: NotificationsComponent,
    canActivate: [],
  },
];



// WEBPACK FOOTER //
// ./src/app/components/dashboard/notifications/notifications.routes.ts